export interface ChatbotEntity {
  id: string;
  name: string;
  type: string;
}

export interface ChatbotMapPoint {
  latitude: number;
  longitude: number;
  popupText?: string;
}

export interface ChatbotMapAsset {
  kind: "map";
  title?: string;
  points: ChatbotMapPoint[];
}

export interface ChatbotImageAsset {
  kind: "image";
  title?: string;
  base64: string;
  mime?: string;
}

export type ChatbotAsset = ChatbotMapAsset | ChatbotImageAsset;

export type ChatbotFeedbackScore = "up" | "down" | null;

export interface ChatbotMessage {
  id: string;
  role: "user" | "bot";
  content: string;
  runId?: string;
  assets?: ChatbotAsset[];
  feedbackScore?: ChatbotFeedbackScore;
  feedbackComment?: string;
  isError?: boolean;
  /**
   * GraphQL error code for an error bubble (e.g. `budget_exceeded`,
   * `rate_limited`), used to pick a specific localized message. Absent -> the
   * generic error message is shown.
   */
  errorCode?: string;
}

export function mapAssets(rawAssets: any[] | null | undefined): ChatbotAsset[] {
  if (!rawAssets) {
    return [];
  }

  return rawAssets.map((asset): ChatbotAsset => {
    if (typeof asset.base64 === "string") {
      return { kind: "image", title: asset.title, base64: asset.base64, mime: asset.mime };
    }

    return { kind: "map", title: asset.title, points: asset.points ?? [] };
  });
}

export function mapEntities(rawEntities: any[] | null | undefined): ChatbotEntity[] {
  return (rawEntities ?? []).map((entity) => ({
    id: entity.id,
    name: entity.name,
    type: entity.type,
  }));
}
